import React from 'react';
import './loader.css';

const IconLoader = () => (
  <div className="sk-chase" id="loader">
    <div className="sk-chase-dot"></div>
    <div className="sk-chase-dot"></div>
    <div className="sk-chase-dot"></div>
    <div className="sk-chase-dot"></div>
    <div className="sk-chase-dot"></div>
    <div className="sk-chase-dot"></div>
  </div>
);

export default IconLoader;
